<template>
  <div v-if="visible" class="sf-modal sf-modal-white sf-modal-top sf-modal-s">
    <div class="sf-modal-backdrop" />
    <div class="sf-modal-container">
      <div class="sf-modal-inner">
        <div class="sf-modal-content sf-c-text sf-pad-v-4">
          <p
            v-dompurify-html="
              I18n.t(
                'user.firm_level_configuration.email_notifications.modal.primary_text_html',
                { option: newSetting }
              )
            "
            class="sf-font-m sf-below-3 sf-align-c sf-pad-h-4 sf-below-2"
          />

          <p
            class="
              sf-bg-warning-subtle-2 sf-align-c sf-pad-3 sf-c-warning sf-below-3
            "
          >
            {{
              I18n.t(
                'user.firm_level_configuration.email_notifications.modal.secondary_text'
              )
            }}
          </p>

          <div class="sf-level sf-level-center sf-level-medium">
            <button type="button" class="sf-btn sf-level-item" @click="close">
              {{ I18n.t('common.cancel') }}
            </button>
            <button
              type="button"
              class="sf-btn sf-btn-success sf-level-item"
              @click="confirm"
            >
              {{
                I18n.t(
                  'user.firm_level_configuration.email_notifications.modal.confirm'
                )
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newSetting: '',
      visible: false,
    }
  },

  methods: {
    openModal({ newSetting, form, submitButton }) {
      this.newSetting = newSetting
      this.form = form
      this.submitButton = submitButton
      this.visible = true
    },

    close() {
      this.visible = false
      this.submitButton.disabled = false
    },

    confirm() {
      this.form.submit()
      this.visible = false
    },
  },
}
</script>
